import { useMe } from '@/hooks/use-me';
import type { PenaltyUnit } from '@/warranty-v3/utils/format-penalty';

export type PenaltyDisplay = {
  label: string;
  unit: PenaltyUnit;
};

export function usePenaltyDisplay(): PenaltyDisplay {
  const me = useMe();

  if (me.config.id === '81') {
    return { label: 'Cycle Penalty', unit: 'number' };
  }
  return { label: 'SOH Penalty', unit: 'percentage' };
}
